// Canonical business stages and modules for Orbit (do not include tasks here)
// Sourced from content_hierarchy.json and content_hierarchy.md
// Icons are referenced by string key; actual icon components are mapped in the UI layer

export enum Stage {
  Explore = 'Explore',
  Incubation = 'Incubation',
  Launch = 'Launch',
  Growth = 'Growth',
}

export enum Module {
  Ideation = 'Ideation',
  Team = 'Team',
  Strategize = 'Strategize',
  Validate = 'Validate',
  Funding = 'Funding',
  Incorporation = 'Incorporation',
  Compliance = 'Compliance',
  FounderReadiness = 'Founder Readiness',
  Build = 'Build',
  Market = 'Market',
  Monetize = 'Monetize',
  GoToMarket = 'GoToMarket',
  Analytics = 'Analytics',
}

export interface ModuleDefinition {
  name: Module;
  icon: string; // icon key, e.g. 'Lightbulb', 'Users', etc.
}

export interface StageDefinition {
  name: Stage;
  icon: string; // icon key, e.g. 'Lightbulb', 'Flask', etc.
  modules: ModuleDefinition[];
}

// Stage color definitions for UI components
export const STAGE_COLORS: Record<Stage, string> = {
  [Stage.Explore]: 'bg-blue-600',
  [Stage.Incubation]: 'bg-purple-600',
  [Stage.Launch]: 'bg-green-600',
  [Stage.Growth]: 'bg-orange-600',
};

// Helper function to get stage color with fallback
export const getStageColor = (stage: string): string => {
  const stageKey = stage as Stage;
  return STAGE_COLORS[stageKey] || 'bg-gray-600';
};

export const BUSINESS_STAGES: StageDefinition[] = [
  {
    name: Stage.Explore,
    icon: 'Lightbulb',
    modules: [
      { name: Module.Ideation, icon: 'Lightbulb' },
      { name: Module.Team, icon: 'Users' },
    ],
  },
  {
    name: Stage.Incubation,
    icon: 'Flask',
    modules: [
      { name: Module.Strategize, icon: 'ChartLine' },
      { name: Module.Validate, icon: 'Flask' },
      { name: Module.Funding, icon: 'Seedling' },
      { name: Module.Incorporation, icon: 'Compass' },
      { name: Module.Compliance, icon: 'Compass' },
      { name: Module.FounderReadiness, icon: 'SquareUser' },
    ],
  },
  {
    name: Stage.Launch,
    icon: 'Compass',
    modules: [
      { name: Module.Build, icon: 'Compass' },
      { name: Module.Market, icon: 'Compass' },
      { name: Module.Monetize, icon: 'Star' },
      { name: Module.GoToMarket, icon: 'Compass' },
    ],
  },
  {
    name: Stage.Growth,
    icon: 'Seedling',
    modules: [{ name: Module.Analytics, icon: 'ChartLine' }],
  },
];
